import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as events from '../../lib/analytics/events';
import CheckoutContext from '../../lib/CheckoutContext';
import useHardwareFirstTotals from './useHardwareFirstTotals';
import styles from './HardwareFirstPromoApplied.module.scss';

/** The code's row once it is on the cart, in place of the field: what it takes off and a way to remove it. */
export default function HardwareFirstPromoApplied() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { cart, checkoutActions } = useContext(CheckoutContext);
  const { promoPercentOff } = useHardwareFirstTotals();
  const code = cart.couponCode;

  if (!code) {
    return null;
  }

  const onRemove = () => {
    dispatch(checkoutActions.removeCoupon(code));
    events.cartPage.couponRemoved(code);
  };

  return (
    <div className={styles.row}>
      <span className={styles.message}>
        {promoPercentOff > 0 ? (
          <Trans
            i18nKey="hardware_first_cart_promo_applied_save"
            components={{ save: <span className={styles.save} /> }}
            values={{ percent: promoPercentOff }}
          />
        ) : (
          t('hardware_first_cart_promo_applied')
        )}
      </span>
      <button className={styles.remove} onClick={onRemove} type="button">
        {t('remove')}
      </button>
    </div>
  );
}
